<div mat-dialog-title>
  <mat-toolbar>
    <label class="headerlabel" [hidden]="!hasDevices">{{'CAMERA.SELECTCAM' |translate}}</label>

    <mat-button-toggle-group [hidden]="!hasDevices">
      @for (device of availableDevices; track device; let i = $index) {
        <mat-button-toggle
          [checked]="isChecked(device)"
          (click)="selectCam(device)"
        [value]="device.deviceId">{{i + 1}}</mat-button-toggle>
      }
    </mat-button-toggle-group>
    <span class="spacer"></span>
    @if (torchAvailable$ | async) {
      <mat-slide-toggle [checked]="torchEnabled" (change)="toggleTorch($event)"
        [hidden]="!hasDevices">
        <mat-icon>flashlight_on</mat-icon>
      </mat-slide-toggle>
    }
    <button mat-icon-button (click)='close()'> <mat-icon>close</mat-icon></button>
  </mat-toolbar>

</div>

<mat-dialog-content class="mat-typography">
  <div class="scanner-shell" [hidden]="!hasDevices">
    <zxing-scanner class="preview"
      #scanner
      [torch]="torchEnabled"
      (scanSuccess)="onCodeResult($event)"
      (permissionResponse)="onHasPermission($event)"
      (camerasFound)="onCamerasFound($event)"
      (camerasNotFound)="camerasNotFoundHandler($event)"
      (torchCompatible)="onTorchCompatible($event)">

    </zxing-scanner>
  </div>

  @if (showNotFound || waitPermission || permissionDenied || accessError) {
    <mat-card appearance="outlined" class="notfoundcard">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon>info</mat-icon>
        </div>
        <mat-card-title>{{'CAMERA.NOTFOUND' |translate}}</mat-card-title>
      </mat-card-header>
      @if (showNotFound) {
        <div>{{'CAMERA.NOTFOUNDTEXT' |translate}}</div>
      }
      @if (waitPermission) {
        <div>{{'CAMERA.WAITINGPERMISSIONTEXT' |translate}}</div>
      }
      @if (permissionDenied) {
        <div>{{'CAMERA.PERMISSIONDENIEDTEXT' |translate}}</div>
      }
      @if (accessError) {
        <div>{{'CAMERA.ACCESSERROR' |translate}}</div>
      }
    </mat-card>
  }
</mat-dialog-content>

